import axios from "axios";
import { APIURL } from "../config";
import useAuth from "../utils/useAuth";


const GetProfileDataAPI = async (data) => {
    const user = useAuth()
    const url = APIURL + "/account/viewprofile"
    return await axios.post(url, { access_token: user.token, ...data })
}

export default GetProfileDataAPI